import { ProductContent } from '@common'
import cx from 'classnames'

import { useProductImage } from '@/features/storefronts/_storeBase/card/utils'
import { ImageWithFallback } from '@/features/storefronts/_storeBase/imageWithFallback/ImageWithFallback'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useAssetColor } from '@/features/storefronts/squadbusters/helpers'
import { useTranslatable } from '@/localization/useTranslatable'

import colors from './colors.module.scss'
import styles from './SquadItem.module.scss'

type Props = {
  content: ProductContent
}

const ProductImage = ({ content }: Props) => {
  const translatable = useTranslatable()
  const title = translatable(content.product.title)
  const asset = useProductImage({ game: 'squadbusters', productId: content.product.id, count: content.amount })

  return (
    <div className={styles.ProductImage}>
      <ImageWithFallback productImage={asset.imageSrc} title={title} />
    </div>
  )
}

const Title = ({ content }: Props) => {
  return (
    <StoreTypography tag="h3" style="outlined" textSize="sm" className={styles.Title}>
      {content.amount}
    </StoreTypography>
  )
}

export const SquadItem = ({ content }: Props) => {
  const colorScheme = useAssetColor(content.product.id)

  return (
    <div className={cx(styles.Card, colors[colorScheme])}>
      <ProductImage content={content} />
      <div className={styles.FooterWrapper}>
        <div className={styles.Footer}>
          <Title content={content} />
        </div>
      </div>
    </div>
  )
}
